<main class="middle-content">
    <div class="content-section">
        <ol class="breadcrumb custom-breadcrumb">
            <li class="breadcrumb-item active">
                <a routerLink="/therapist">Therapist Management </a>
            </li>
            <li class="breadcrumb-item">View</li>
        </ol>
        <div class="order-view mt30 max-WT-700 mrgn-0-auto">

            <div class="main-block-innner mb40 mt40">
                <div class="add-store-block input-style">

                    <!-- **********************Subadmin profile image ****************  -->

                    <div class="text-center mt-4 mb-5">
                        <div class="flex-block align-center">
                            <div class="profile_block" style="position: relative">
                                <img [src]="imageUrl || 'assets/img/profile-img.jpg'" class="imagePicture"
                                    alt="Patient image" (error)="onImageError($event)" />
                                <br />
                            </div>
                        </div>
                    </div>
                    <form>
                        <div class="form-group row  align-items-baseline">
                            <label class="col-md-5">
                                <h6> Type -</h6>
                            </label>
                            <div class="col-md-7">
                                <p>{{viewTherapist?.role}}</p>
                            </div>

                        </div>

                        <div class="row align-items-baseline">
                            <div class="col-md-5">
                                <label>
                                    <h6> Selected Program :</h6>
                                </label>
                            </div>

                        </div>
                        <div class="row align-items-baseline form-group">
                            @for (program of viewTherapist?.assignedPrograms; track program; let i = $index) {
                            <div class="col-md-6 d-flex">
                                <span>{{program?.title}}</span>
                            </div>
                            }
                        </div>

                        <div class="form-group row align-items-baseline">
                            <label class="col-md-5">
                                <h6> First Name :</h6>
                            </label>
                            <div class="col-md-7">
                                <p>{{viewTherapist?.firstName}}</p>

                            </div>
                        </div>

                        <div class="form-group row align-items-baseline">
                            <label class="col-md-5">
                                <h6> Last Name :</h6>
                            </label>
                            <div class="col-md-7">
                                <p>{{viewTherapist?.lastName}}</p>

                            </div>
                        </div>


                        <div class="form-group row align-items-baseline">
                            <label class="col-md-5">
                                <h6> Email :</h6>
                            </label>
                            <div class="col-md-7">
                                <p>{{viewTherapist?.email}}</p>
                            </div>
                        </div>
                        <div class="form-group row align-items-baseline">
                            <label class="col-md-5">
                                <h6>Phone Number : </h6>
                            </label>

                            <div class="col-md-7">
                                <p>{{viewTherapist?.mergeContact}}</p>

                            </div>

                        </div>





                        <div class="form-group row align-items-baseline">
                            <label class="col-md-5">
                                <h6> Speciality :</h6>
                            </label>
                            <div class="col-md-7">
                                <p>{{viewTherapist?.speciality}}</p>
                            </div>
                        </div>

                        <div class="form-group row align-items-baseline">
                            <label class="col-md-5">
                                <h6> Degree :</h6>
                            </label>
                            <div class="col-md-7">
                                <p>{{viewTherapist?.degree}}</p>
                            </div>
                        </div>

                        <div class="form-group row align-items-baseline">
                            <label class="col-md-5">
                                <h6> Institution :</h6>
                            </label>
                            <div class="col-md-7">
                                <p>{{viewTherapist?.institution}}</p>
                            </div>
                        </div>

                        @if(viewTherapist?.myPatient.length){
                        <div class="form-group row align-items-baseline">
                            <label class="col-md-12">
                                <h6> Assigned Patient :</h6>
                            </label>
                        </div>
                        }
                        <div class="row align-items-baseline">
                            @for (pat of viewTherapist?.myPatient; track pat; let i = $index) {
                            <div class="col-md-6 d-flex">
                                <label>{{i+1}}. {{pat?.firstName}} {{pat?.lastName}}</label>
                            </div>
                            }
                        </div>


                        <div class="text-center my-4">
                            <button class="btn btn-theme px-4" routerLink="/therapist">Back</button>
                        </div>

                    </form>


                </div>
            </div>
        </div>
    </div>
</main>